export default "__VITE_ASSET__DGWTO2b6__"